<!--采购订单详情页面-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog">
    <div ref="print1" style="width: 850px;margin: 0 auto;">
      <div style="width: 640px;margin: 0 auto;text-align: right;"><img v-if="imgpath" :src="imgpath"/></div>
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="query-table">
        <tr class="noborder">
          <td align="right">订单号：</td>
          <td>{{controlData.erpserial}}<span v-if="controlData.isfile&&controlData.isfile==1" style="padding-left: 5px;color: red"><b>赠 送</b></span></td>
          <td align="right">时&nbsp;&nbsp;&nbsp;&nbsp;间：</td>
          <td>{{controlData.adddate}}</td>
          <td align="right">入&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td>
            {{controlData.cangkuname}}
            <el-select v-model="controlData.warehouse" size="mini" style="width: 100px" v-if="warehouse.length>1&&isshowqr">
              <el-option v-for="item in warehouse" :key="item.serial" :label="item.name" :value="item.serial">
              </el-option>
            </el-select>
            <span v-if="!isshowqr">{{controlData.warehousename}}</span>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right" width="60">供应商：</td>
          <td width="140">{{controlData.pcustomer||""}}</td>
          <td align="right" width="80">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：</td>
          <td width="220">{{controlData.caddress||""}}</td>
          <td align="right" width="60">联系人：</td>
          <td width="140">{{(controlData.clinkman||"")+" " +(controlData.clinkmantel||"")}}</td>
        </tr>
        <!--<tr class="noborder">-->
        <!--<td align="right">收货方：</td>-->
        <!--<td width="140">{{controlData.servedname||""}}</td>-->
        <!--<td align="right">收货地址：</td>-->
        <!--<td width="220">{{controlData.address||""}}</td>-->
        <!--<td align="right">联系人：</td>-->
        <!--<td width="140">{{(controlData.linkman||"")+" " +(controlData.linkmantel||"")}}</td>-->
        <!--</tr>-->
        <tr class="noborder" v-show="isshowqr&&!supplytaskid">
          <td align="right">商品条码：</td>
          <td width="140">
            <el-input v-model="goodsbarcode" size="mini" @change="selectbarcode" ref="goodsbarcode"></el-input>
          </td>
          <td align="right"> 唯一码：</td>
          <td width="220">
          <el-input v-model="storegoodsbarcode" size="mini" ref="storegoodsbarcode" @change="stockbarcode"></el-input>
          </td>
          <td align="right"> 光度码：</td>
          <td width="140">
          <el-input v-model="scanpowercode" size="mini" ref="scanpowerInput" onfocus="this.select()" placeholder="扫光度码" @change="scanPowerCode"></el-input>
          </td>
        </tr>
        <tr class="noborder" v-show="!isshowqr">
          <td align="right">跟踪号：</td>
          <td width="140">{{controlData.logisticstracknum||""}} <i class="el-icon-picture" style="cursor: pointer" v-if="controlData.logisticstracknum&&controlData.logisticstracknum.length==12" @click="showTracknum"></i></td>
          <td align="right">供应号：</td>
          <td colspan="3">
            <a @click="showSupplyOrder()" style="cursor: pointer;color: dodgerblue" v-if="FastCheck">{{controlData.tracknum}}</a>
            <a v-else>{{controlData.tracknum}}</a>
            <el-button size="mini" v-if="supplytaskid&&supplytaskid=='buysplit'" round @click="showEssilorMore">查看更多</el-button>
          </td>
        </tr>
        <tr class="noborder" v-show="isshowqr">
          <td align="right">跟踪号：</td>
          <td width="140">
            <el-input v-model="logisticstracknum" size="mini" ref="logisticstracknum" placeholder="请输入跟踪单号"
                      onfocus="this.select()"
            ></el-input>
          </td>
          <td align="right">供应号：</td>
          <td width="220">
            <a @click="showSupplyOrder()" style="cursor: pointer;color: dodgerblue" v-if="FastCheck">{{controlData.tracknum}}</a>
            <el-input v-else v-model="tracknum" size="mini" ref="tracknum" placeholder="请输入供应商单号"
                      onfocus="this.select()"></el-input>
            <el-button type="success" size="mini" plain @click="fastCheckIn" v-if="FastCheck">快速入库</el-button>
          </td>
          <td>
            <el-button size="mini" v-if="supplytaskid&&supplytaskid=='buysplit'" round @click="showEssilorMore">查看更多</el-button>
            <el-button type="danger" size='mini' @click="adjust" v-if="isshowqr&&(caiGouRukuData.length>0)">调整订单数量
            </el-button>
          </td>
          <td v-if="noscancode">
            <el-button type="warning" size='mini' v-on:click="productimport($event)">导入</el-button>
            <a href="./static/file/采购单唯一码模板.xls" download="C:/Users/Public">下载模板</a>
            <input type="file" ref="fileupload" style="display: none;" @change="change1($event)"/>
          </td>
        </tr>
        <tr class="noborder" v-if="saleorder.returnerpserial"
            @click="lookTuihuo()">
          <td align="right">退货单：</td>
          <td width="140">{{saleorder.returnerpserial}}</td>
        </tr>
      </table>
      <table v-for="(obj,indextable) in this.tableData" style="border-collapse:collapse;width:100%;margin-top: 20px">
        <tr class="noborder" v-show="showtablehead">
          <td align="left" width="70">关联单号：</td>
          <td align="left" width="120" style="font-weight:bold;cursor:pointer"
              @click="lookDetails()">{{saleorder.erpserial}}
          </td>
          <td align="left" width="70" v-if="saleorder.htqd">下单日期：</td>
          <td align="left" width="120">{{saleorder.htqd}}</td>
          <td align="right">数量合计：{{controlData.sumnumber}}</td>
          <!--<td align="left" width="80">应交付日期：</td>-->
          <!--<td align="left">{{obj.jhjgrq}}</td>-->
        </tr>
        <tr>
          <td colspan="6" style="border:none">
            <table cellspacing="0" cellpadding="0" border="0"
                   style="border-collapse:collapse;width:100%;fontSize:'18px'"
                   class="query-table">
              <tr>
                <td
                  v-if="item !='seedcode' && item !='unitguid'&& item !='关联产品'&& item !='subseedcode'&& item !='packagesize'&&item!='bcode'&&((isprint&&item!='总价'&&item!='单价')||!isprint)&&((roletype=='store'&&item!='总价'&&item!='单价')||roletype!='store')"
                  style="text-align: center" v-for="item in obj['column']">
                  {{item}}
                </td>
              </tr>
              <tr v-for="(item,index) in obj['billmap']" style="cursor:pointer;" @click="showDetail(item,0,obj)">
                <td
                  :style="{textAlign:ob['产品名称']?'left':'center',minWidth:ob['产品名称']?'150px':''}"
                  v-for="(ob,index) in item"
                  v-if="index!=0&&typeof(ob['关联产品'])=='undefined'&&typeof(ob['subseedcode'])=='undefined'&&typeof(ob['packagesize'])=='undefined'&&index!=(item.length-1)&&((isprint&&typeof(ob['总价'])=='undefined'&&typeof(ob['单价'])=='undefined')||!isprint)&&((roletype=='store'&&typeof(ob['总价'])=='undefined'&&typeof(ob['单价'])=='undefined')||roletype!='store')">
                    <span v-for="(value,i) in ob" v-if="index!=0">{{i == "单价" || i == "总价" ? parseFloat(value || 0).toFixed(3) : value}}
                    <div v-for="(value,i) in ob" v-if="i=='产品名称'" v-html="getGuanLGoods(item)"></div>
                    <span style="color: red">{{i == "数量"?(item[item.length - 1]['bcode']==undefined||item[item.length - 1]['bcode']==0?'':'/'+item[item.length - 1]['bcode']):""}}</span></span>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr class="noborder">
          <td width="70">说&nbsp;&nbsp;&nbsp;&nbsp;明：</td>
          <td colspan="5" style="text-align: left">
            <div v-html="getLiuYan(obj.remark)"></div>
          </td>
        </tr>
        <tr class="noborder">
          <td colspan="6" style="border:none">
            <table>
              <tr v-for="item in obj['formpropertyData']">
                <td align="left" style="padding-left: 0px;padding-right: 0px;" width="160"
                    v-for="(item2,index) in item">
                  <span style="width:80px;display: inline-block;text-align: right">{{index+"："}}</span>
                  <span style="width:70px;display: inline-block;text-align: left">{{item2}}</span>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr v-if="indextable !=tableData.length-1">
          <td colspan="6">
            <div id=content style="border:1px dashed #334455;width: 100%"></div>
          </td>
        </tr>
      </table>
      <table style="border-collapse:collapse;width:100%;margin-top: 20px">
        <tr class="noborder">
          <td colspan="2">入库人员：</td>
          <td colspan="2">制单人员：{{controlData.uname}}</td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="close">取 消</el-button>
      <el-button type="success" @click="outgoodsScan" class="qrbtn" v-if="isBack&&qrcodescan" :disabled="isDisable">扫码</el-button>
      <el-button type="success" @click="beforeupdate(true)" v-show="!supplytaskid&&!isBack&&isshowqr&&qrcodescan&&!isBack" :disabled="isDisable">入库&打码</el-button>
      <el-button type="primary" @click="openQRCode()" v-show="!supplytaskid&&!isBack&&!isshowqr&&(saleorder.erpserial||controlData.status==820)&&qrcodescan" :disabled="isDisable">打码</el-button>
      <!--<el-button @click="inputBatch" type="success" v-if="!supplytaskid" plain :disabled="isDisable">录入批号</el-button>-->
      <el-button type="primary" @click="beforeupdate(false)" v-show="!supplytaskid&&isshowqr" :disabled="isDisable">确认入库</el-button>
      <el-button type="primary" @click="delivergoodsScan(false)" v-show="supplytaskid&&isshowqr" :disabled="isDisable">扫码入库</el-button>
      <el-button type="primary" @click="delivergoodsScan(true)" v-show="supplytaskid&&controlData.status==820&&!saleorder.erpserial" :disabled="isDisable">补推物流码</el-button>
      <el-button type="primary" v-if="showedit&&!FastCheck&&!showtablehead&&controlData.status!=820"  @click="showDetail(tableData[0]['billmap'][0],1)">修改</el-button>
      <el-button type="primary" @click="print1">打印</el-button>
      <span @click="handleloglook" style="position: absolute;bottom: 25px;right: 10px">(处理日志)</span>
      <el-button type="text" @click="exportExcel" size="mini">导出</el-button>
      <el-button type="text" v-if="status=='810'" size="mini" @click="exportExceltable">导出二维表</el-button>
    </div>
    <BuyOrderEditSeedDetail ref="seeddetail" @bindGrid="initData"></BuyOrderEditSeedDetail>
    <HandlelogList ref="HandlelogList"></HandlelogList>
    <StorageBadDetail ref="StorageBadDetail"></StorageBadDetail>
    <StorageBadOut ref="StorageBadOut"></StorageBadOut>
    <BaoSunDetail ref="BaoSunDetail"></BaoSunDetail>
    <CstagreementEdit ref="DataContactEdit"></CstagreementEdit>
    <BuyfromList ref="BuyfromList"></BuyfromList>
    <BuyfromListEssilor ref="BuyfromListEssilor"></BuyfromListEssilor>
    <BuyfromFastCheck ref="BuyfromFastCheck" @afterCheckIn="afterCheckIn"></BuyfromFastCheck>
    <ScanCode ref="ScanCode" @scancodeedit="scancodeedit" @clearscancode="clearscancode"></ScanCode>
    <ScanCodeBatch ref="ScanCodeBatch" @scancodeedit="scancodeloadBatch" @clearscancode="scancodeloadBatch"></ScanCodeBatch>
    <QRCodeCreate ref="QRCodeCreate1"></QRCodeCreate>
    <ScanCodeSupplyer4Buy ref="ScanCodeSupplyer" @scancodeedit="scancodeloadSupply"></ScanCodeSupplyer4Buy>
    <QRCodeScan ref="QRCodeScan1" @scancodeedit="afterQRCodeScan"></QRCodeScan>
  </el-dialog>
</template>

<script>
  import {printingbuy} from '@/api/set/csagreement';
  import {bardetail} from '@/api/set/jxcgoodsbarcode';
  import {getRemark} from '@/plugin/ordercommon';
  import {exportExcel} from '@/api/file'
  import {detailEssilor} from '@/api/attachment'
  import HandlelogList from '@/components/testorder/cstagreement/HandlelogList'
  import ScanCodeSupplyer4Buy from './ScanCodeSupplyer4Buy';
  import {
    getCstagreementListDataNew,
    cstagreementDeleteData,
    cstagreementUpdateData,
    buyodersave, jxcstorelist,
    updatebuyorder, updateFastbuyorder, adjustNumber
  } from '@/api/set/csagreement';
  import {checkModuleRight} from '@/api/login'
  import {cusandptbyind} from '@/api/set/jxcstore';
  import BuyOrderEditSeedDetail from './BuyOrderEditSeedDetail'
  import StorageBadDetail from '@/components/warehouse/StorageBadDetail'
  import {saveData, getListData} from '@/api/set/handlelog';
  import {getDetail} from '@/api/set/jxcgooddetail';
  import StorageBadOut from '@/components/warehouse/StorageBadOut'
  import BaoSunDetail from '@/components/testorder/cstagreement/BaoSunDetail';
  import CstagreementEdit from '@/components/testorder/cstagreement/CstagreementEdit';
  import ScanCode from '@/components/testorder/cstagreement/ScanCode';
  import ScanCodeBatch from '@/components/testorder/cstagreement/ScanCodeBatch';
  import QRCodeCreate from './QRCodeCreate';
  import BuyfromList from '@/components/testorder/buyagreement/BuyfromList'
  import BuyfromListEssilor from '@/components/testorder/buyagreement/BuyfromListEssilor'
  import BuyfromFastCheck from '@/components/testorder/buyagreement/BuyfromFastCheck'
  import {formatTimeToStr} from '@/plugin/Date';
  import {getPrice} from '@/api/set/goodsprice';
  import QRCodeScan from './QRCodeScan';
  import {listBar} from '@/api/set/jxcstoregoodsbar';

  export default {
    name: 'BuyorderDetail',
    data() {
      return {
        totalScanNum:0,
        showQRCode:false,
        isSplitOrder:false,
        isDisable: false,//防止多次提交
        goodsbarcode: '',//商品条码
        storegoodsbarcode: '',//库存商品唯一条码
        scanpowercode: '',//光度码
        flage: true,//数量选择区分显示列
        isprint: false,
        isBack:false,
        imgpath: '',
        qrcodescan:false,
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        groupguid: '',
        seedcode: "",
        remark: '',
        showedit:true,
        FastCheck: false,
        showtablehead: true,
        unitguid: '',
        cangkucode: '',
        htje: '',
        cangkuname: '',
        roletype: "",
        isupdatechange: false,
        supplytaskid:'',
        tableData: [
          {column: [], totalnumber: []},
        ],
        tableData1: [],
        column: [],
        saleorder: {erpserial: '', ht1d: '', returnerpserial: ''},
        isshowqr: false,
        isbuyorder: '',
        controlData: {warehouse:''},
        showtitle1: "none",
        jxcstoreData: [],
        caiGouRukuData: [],//采购入库条码
        goodsbar: {},//商品条形码
        tracknum: '',//供应商单号
        logisticstracknum: '',//跟踪单号
        oldTotalNum: 0,//原订单总数量
        scancodes: [],//唯一码
        noscancode: false,//是否需要唯一码扫码
        initContent: [],//导出二维表
        initContentLeft: [],//导出二维表左眼
        initContentRight: [],//导出二维表右眼
        costpricebook: {},
        xcolumn: [],
        ycolumn: [],
        warehouse:[],
        status: '',
      }
    },
    methods: {
      outgoodsScan() {//扫码发货
        if (this.controlData.invoicesource == 1) {
          this.$message({message: '未审核的采购订单！',type: 'warning'})
          return;
        }
        var arr=[]
        for(let i in this.controlData.billmap) {
          var row = this.controlData.billmap[i]
          if(row['产品名称']=='合计') continue;
          for(let j=0;j<Math.abs(row['数量']);j++) {
            arr.push({
              seedcode: row.seedcode,
              seedname: row['产品名称'],
              packagesize: row.packagesize, storegoodsbarcode: '', starttime: '', endtime: ''
            })
          }
        }
        this.$refs.QRCodeScan1.show({
          cangkucode: this.controlData.cangkucode,
          erpserial: this.controlData.erpserial,
          seedcode: '',
          goods:arr
        }, this.isshowqr);
      },
      afterQRCodeScan(scancodes) {//扫码后提交(退货时才有)
        this.noscancode=false;
        this.scancodes=[];
        this.caiGouRukuData=[];
        this.update();
      },
      inputBatch() {
        this.$refs.ScanCodeBatch.show(this.controlData, this.scancodes, this.isshowqr);
      },
      fastCheckIn() {
        this.$refs.BuyfromFastCheck.show(this.controlData.tracknum, this.controlData.pcustomerserial, this.tableData);
      },
      showSupplyOrder() {//显示供应商系统中的订单
        this.$refs.BuyfromList.show(this.controlData.tracknum, this.controlData.pcustomerserial);
      },
      showEssilorMore(){
        this.$refs.BuyfromListEssilor.show(this.controlData.erpserial);
      },
      showTracknum() {
        detailEssilor({tracknum: this.controlData.logisticstracknum}).then(response => {
          if (response.data.code == 0) {
            window.open(response.data.msg);
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
        });
      },
      delivergoodsScan(aftersend) {//扫码发货
        this.controlData.supplytaskid=this.supplytaskid;
        this.controlData.aftersend=aftersend;
        this.$refs.ScanCodeSupplyer.show(this.controlData, this.scancodes, this.isshowqr);
      },
      scancodeloadSupply(scancodes) {//同步收货
        this.caiGouRukuData = scancodes
        this.scancodeloadBatch(scancodes);
        if (this.totalScanNum > 0) {
          this.update();
        }  else {
          this.$message({
            message: '缺少条码！',
            type: 'error'
          })
          this.isDisable = false
          return
        }
      },
      //唯一码扫码数量
      scancodeloadBatch(scancodes) {
        this.scancodes = scancodes;
        for(let j=0;j<scancodes.length;j++) {
          scancodes[j]["hasSet"] = 0;
        }

        this.totalScanNum = 0
        //bcode是唯一码的数量
        for (let g = 0; g < this.tableData[0]['billmap'].length; g++) {
          var arr = this.tableData[0]['billmap'][g];

          var seedcode = ''
          var packagesize = ''
          var maxnum=0;
          for (let j = 0; j < arr.length; j++) {
            if (arr[j].hasOwnProperty('seedcode'))
              seedcode = arr[j]['seedcode'];
            if (arr[j].hasOwnProperty('packagesize'))
              packagesize = arr[j]['packagesize'];
            if (arr[j].hasOwnProperty('数量'))
              maxnum = parseInt(arr[j]['数量']);
          }
          if(seedcode=='') {
            continue;
          }

          if(packagesize==null||packagesize=='') {//不用扫码
            num = maxnum;
          }else {
            var scanC = scancodes.filter(o => o.seedcode == seedcode && o.packagesize == packagesize && o.hasSet == 0 && (o.goodsbarcode || o.storegoodsbarcode));
            var num = 0;
            for (let j = 0; j < scanC.length; j++) {
              if (j < maxnum) {
                scanC[j]["hasSet"] = 1;
                num += 1;
              } else
                break;
            }
          }

          for (let j = 0; j < arr.length; j++) {
            if (arr[j].hasOwnProperty('bcode')) {
              this.totalScanNum += num;
              arr[j]['bcode'] = num;
            }
          }
        }
      },
      scancodeedit(scancodes, totalnumber) {
        if (scancodes.length > 0) {
          if (this.scancodes.length > 0 && scancodes[0].goodsbarcode != '') {
            var oldcode = JSON.parse(JSON.stringify(this.scancodes))
            this.scancodes = []
            //防止冒泡
            for (let i in oldcode) {
              if (scancodes[0].seedcode != oldcode[i].seedcode) {
                this.scancodes.push(oldcode[i])
              }
            }
            this.scancodes = this.scancodes.concat(scancodes)

          } else {
            this.scancodes = scancodes
          }

          //bcode是唯一码的数量
          for (let g = 0; g < this.tableData.length; g++) {
            var arr = this.tableData[g]['billmap'];
            for (let j = 0; j < arr.length; j++) {
              var seedcode = arr[j][0]['seedcode']
              if (seedcode == scancodes[0].seedcode) {
                arr[j][arr[j].length - 1]['bcode'] = totalnumber
              }
            }
          }

        }
      },
      //唯一码清除时调用
      clearscancode(seedcode) {
        for (let g = 0; g < this.tableData.length; g++) {
          this.tableData[g]['billmap'] = this.tableData[g]['billmap'].map(o1 => {
            if (seedcode == o1[0]['seedcode']) {
              o1[o1.length - 1]['bcode'] = 0;
            }
            return o1;
          })
        }
        //清除选择的商品
        var oldscan = JSON.parse(JSON.stringify(this.scancodes))
        this.scancodes = []
        for (let i = 0; i < oldscan.length; i++) {
          if (oldscan[i].seedcode != seedcode) {
            this.scancodes.push(oldscan[i]);
          }
        }
      },
      //商品条码
      selectbarcode(val) {
        this.storegoodsbarcode = ''
        var form = {
          barcode: val
        }
        bardetail(form).then(response => {
          this.goodsbar = response.data.obj
          if (this.goodsbar == undefined) {
            this.$message({
              message: '条码无效',
              type: 'error'
            })
            this.isDisable = false
            this.goodsbarcode = ''
            return
          }
          if (this.goodsbar != undefined && this.goodsbar.noscancode == 1) {
            this.$message({
              type: 'warning',
              message: '此商品请扫唯一码'
            })
            this.goodsbarcode = ''
            return
          }
          //商品条码
          this.goodsbar.goodsbarcode = this.goodsbar.barcode
          //仓库编码
          this.goodsbar.cangkucode = this.controlData.cangkucode
          //采购单编码
          this.goodsbar.erpserial = this.controlData.erpserial
          this.$refs.storegoodsbarcode.focus()
          //this.stockbarcode()
        })
      },
      getMapValue(ol, col) {
        var ret = '';
        for (let j = 0; j < ol.length; j++) {
          if (ol[j].hasOwnProperty(col))
            ret = ol[j][col];
        }
        return ret;
      },
      getGuanLGoods(rows) {
        var goods = this.getMapValue(rows, '关联产品');
        if (goods)
          return '<div style="float: left;padding-left: 30px">' + goods + '</div>'
        return '';
      },
      //库存商品唯一条码
      stockbarcode(val) {
        //扫描库存商品唯一条码前必须先扫描商品条码
        if (this.goodsbarcode == '') {
          this.$message({
            message: '请先扫商品条码！',
            type: 'error'
          })
          this.storegoodsbarcode = ''
          return
        }
        //判断库存条码是否有重复的
        if (this.caiGouRukuData.length > 0) {
          for(let i in this.caiGouRukuData) {
            if (this.caiGouRukuData[i].storegoodsbarcode == val) {
              this.$message({
                message: '唯一码不可重复',
                type: 'error'
              })
              this.storegoodsbarcode = ''
              return
            }
          }
        }

        //更新billmap（ 产品明细）
        if (this.tableData.length > 0) {
          var seedname = '';//商品名称
          var packagesize = '';//商品光度
          var count = 0//判断是否已达上限
          var compare = false//判断是否存在商品码
          for (let g = 0; g < this.tableData.length; g++) {
            this.tableData[g]['billmap'] = this.tableData[g]['billmap'].map(o1 => {
              var X = '';
              var Y = '';
              var seedcode = '';
              seedcode = this.getMapValue(o1, 'seedcode');
              Y = this.getMapValue(o1, '球镜');
              X = this.getMapValue(o1, '柱镜');
              if (this.goodsbar.filltemplate == 40) {
                if (seedcode == this.goodsbar.seedcode) {
                  //判断商品数量大于扫描数量加1,否则继续向下循环
                  compare = true
                  if (o1[o1.length - 1]['bcode'] > 0) {
                    //判断商品数量大于扫描数量加1,否则继续向下循环
                    if (this.getMapValue(o1, '数量') > o1[o1.length - 1]['bcode']) {
                      ++count;
                      o1[o1.length - 1]['bcode'] = ++o1[o1.length - 1]['bcode']
                      //库存商品唯一编码
                      this.goodsbar.storegoodsbarcode = val
                      this.goodsbar.status = this.controlData.status
                    }
                  } else {
                    o1[o1.length - 1]['bcode'] = 1
                    ++count;
                    //库存商品唯一编码
                    this.goodsbar.storegoodsbarcode = val
                    this.goodsbar.status = this.controlData.status
                  }
                }
              } else {
                //商品编码、光度一样需要一样
                if (seedcode == this.goodsbar.seedcode && Number(X) == Number(JSON.parse(this.goodsbar.packagesize).X) && Number(Y) == Number(JSON.parse(this.goodsbar.packagesize).Y)) {
                  //判断商品数量大于扫描数量加1,否则继续向下循环
                  compare = true
                  if (this.goodsbar.filltemplate == 20 || this.goodsbar.filltemplate == 30) {
                    packagesize = "{球镜：" + JSON.parse(this.goodsbar.packagesize).Y + ",柱镜：" + JSON.parse(this.goodsbar.packagesize).X + ",type:" + JSON.parse(this.goodsbar.packagesize).type + "}"
                    seedname = this.getMapValue(o1, '产品名称')
                  } else {
                    packagesize = "{球镜：" + JSON.parse(this.goodsbar.packagesize).Y + ",柱镜：" + JSON.parse(this.goodsbar.packagesize).X + "}"
                    seedname = this.getMapValue(o1, '产品名称')
                  }
                  //判断是否已扫描
                  if (o1[o1.length - 1]['bcode'] > 0) {
                    //判断商品数量大于扫描数量加1,否则继续向下循环
                    if (this.getMapValue(o1, '数量') > o1[o1.length - 1]['bcode']) {
                      ++count;
                      o1[o1.length - 1]['bcode'] = ++o1[o1.length - 1]['bcode']
                      //库存商品唯一编码
                      this.goodsbar.storegoodsbarcode = val
                      this.goodsbar.status = this.controlData.status
                      //将数据添加到采购入库数组中
                      this.caiGouRukuData.push(this.goodsbar)
                    }
                  } else {
                    // this.$set(o1, o1.length, {'bcode': 1})
                    o1[o1.length - 1]['bcode'] = 1
                    ++count;
                    //库存商品唯一编码
                    this.goodsbar.storegoodsbarcode = val
                    this.goodsbar.status = this.controlData.status
                    //将数据添加到采购入库数组中
                    this.caiGouRukuData.push(this.goodsbar)
                  }
                }
              }
              return o1;
            })
          }
          //商品光度 不存在提示
          if (!compare) {
            this.$alert('商品光度不存在', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.$message({
                  type: 'info',
                  message: `请重新扫码!`
                });
              }
            });
            this.goodsbarcode = ''
            this.storegoodsbarcode = ''
            return
          }
          //该商品已达上限提示
          if (count == 0) {
            this.$alert('该' + seedname + packagesize + '已达到上限', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.$message({
                  type: 'info',
                  message: `请继续扫码!`
                });
              }
            });
            this.goodsbarcode = ''
            this.storegoodsbarcode = ''
            return
          }
        }
        this.goodsbarcode = ''
        this.storegoodsbarcode = ''
        this.$refs.goodsbarcode.focus()
      },
      //扫光度码（增加已采购数量）
      scanPowerCode() {
        if (!this.scanpowercode)
          return;
        const _this = this;
        bardetail({barcode: this.scanpowercode}).then(response => {
          _this.scanpowercode = '';
          if (!response.data.obj || response.data.code != 0 || !response.data.obj.seedcode) {
            _this.$message({ message: '光度码无效！', type: 'error' });
            _this.$nextTick(() => { _this.$refs.scanpowerInput.focus(); });
            return;
          }
          const obj = response.data.obj;
          const seedcode = obj.seedcode;
          let packagesizeObj;
          try {
            packagesizeObj = JSON.parse(obj.packagesize || '{}');
          } catch (e) {
            _this.$message({ message: '光度码数据格式错误', type: 'error' });
            _this.$nextTick(() => { _this.$refs.scanpowerInput.focus(); });
            return;
          }
          const Y = parseFloat(packagesizeObj.Y) || 0;
          const X = parseFloat(packagesizeObj.X) || 0;
          let matched = false;
          let count = 0;
          let seedname = '';
          // 在tableData中查找匹配的记录并增加已采购数量
          for (let g = 0; g < _this.tableData.length; g++) {
            _this.tableData[g]['billmap'] = _this.tableData[g]['billmap'].map(o1 => {
              const itemSeedcode = _this.getMapValue(o1, 'seedcode');
              const itemY = parseFloat(_this.getMapValue(o1, '球镜')) || 0;
              const itemX = parseFloat(_this.getMapValue(o1, '柱镜')) || 0;
              const qty = parseFloat(_this.getMapValue(o1, '数量')) || 0;
              if (itemSeedcode == seedcode && itemY == Y && itemX == X) {
                matched = true;
                seedname = _this.getMapValue(o1, '产品名称');
                const currentBcode = o1[o1.length - 1]['bcode'] || 0;
                if (currentBcode < qty) {
                  o1[o1.length - 1]['bcode'] = currentBcode + 1;
                  count++;
                }
              }
              return o1;
            });
          }
          if (!matched) {
            _this.$message({ message: '未找到匹配的商品！请核对', type: 'warning' });
          } else if (count == 0) {
            _this.$message({ message: seedname + ' 已达到采购上限', type: 'warning' });
          }
          _this.$nextTick(() => { _this.$refs.scanpowerInput.focus(); });
        }).catch(() => {
          _this.scanpowercode = '';
          _this.$message({ message: '光度码查询失败', type: 'error' });
          _this.$nextTick(() => { _this.$refs.scanpowerInput.focus(); });
        });
      },
      //导入
      productimport() {
        this.$refs.fileupload.value = ""
        this.$refs.fileupload.click()
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
            if (typeof data == "object" && (Array.isArray(data) || obj1 instanceof Array)) {
              var seedcodes = []
              var codes = []
              data.forEach((item) => {
                if (item['编码']) {
                  seedcodes.push(item['编码'])
                  codes.push(item['唯一码'])
                } else {
                  data.splice(data.indexOf(item), 1)
                }
              })

              //去重
              if (seedcodes.length > 0) {
                seedcodes = Array.from(new Set(seedcodes))
              }

              //去重后的唯一码数组对比原数据数组数量相同就是没有唯一码重复的
              if (codes.length > 0) {
                if (Array.from(new Set(codes)).length != data.length) {
                  this.$message({
                    message: '唯一码有重复的！',
                    type: 'warning'
                  })
                  return
                }
              }
              for (let i in seedcodes) {
                var scancodes = []
                var totalnumber = 0
                data.forEach((item) => {
                  if (seedcodes[i] == item['编码']) {
                    totalnumber++
                    let obj = {}
                    obj.seedcode = item['编码']
                    obj.seedname = item['名称']
                    obj.cangkucode = this.controlData.cangkucode
                    obj.erpserial = this.controlData.erpserial
                    obj.totalnumber = 1
                    obj.goodsbarcode = item['唯一码']
                    scancodes.push(obj)
                  }
                })
                this.scancodeedit(scancodes, totalnumber)
              }
            }
          })

        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      //查看退货
      lookTuihuo() {
        this.controlData.parenterpserial = this.saleorder.returnerpserial;
        this.$refs.StorageBadDetail.initData(this.controlData)
      }
      ,
      //查看处理日志
      handleloglook() {
        this.$refs.HandlelogList.show()
        this.$refs.HandlelogList.initData(this.erpserial);
      }
      ,
      //处理日志
      handlelog() {
        var handlelog = {}
        handlelog.erpserial = this.erpserial
        handlelog.isopen = 1
        handlelog.insub = 1
        handlelog.totalnumber=this.oldTotalNum
        handlelog.casestepname = '采购入库'
        handlelog.remark = this.controlData.cangkuname + '已收货'
        saveData(handlelog).then(response => {})
      }
      ,
      getTitle() {
        let result = "";
        let temp = localStorage.getItem("hpapi_userInfoModel")
        if (temp) {
          result += JSON.parse(temp).tenantname || ""
        }
        result += "采购订单"
        return result
      }
      ,
      lookDetails() {
        switch (this.saleorder.erpserial.substring(0, 2)) {
          case "78":
            this.$refs.BaoSunDetail.show(this.saleorder.erpserial);
            break;
          case "79":
            this.$refs.StorageBadOut.show(this.saleorder.erpserial);
            break;
          default:
            let row = {
              erpserial: this.saleorder.erpserial
            }
            this.$refs.DataContactEdit.initData(row)
            this.$refs.DataContactEdit.show()
            break;
        }
      }
      ,
      getLiuYan(remark) {
        return getRemark(remark);
      }
      ,

      close() {
        //当采购单发送修改的时候需要刷新主页面
        if (this.isupdatechange) {
          this.$emit('bindGrid');
        }
        this.dialogSeeVisible = false;
      }
      ,

      print1() {
        // window.print()
        this.showtitle1 = ""
        this.isprint = true
        this.$nextTick(() => {
          this.$print(this.$refs.print1)
          this.isprint = false
          this.showtitle1 = "none"
        })
      }
      ,
      exportExcel(title) {
        var dataexcel = {
          tableData: JSON.stringify(this.tableData),
          controlData: JSON.stringify(this.controlData),
          businessType: 'buyerorder'
        }
        exportExcel(dataexcel)
      },
      getXYRange(seedcode) {
        getPrice({seedcode: seedcode, filterType: "cost", notneedconnectprice: true}).then((response) => {
          if (response.data.code == 0 && response.data.obj) {
            this.costpricebook = response.data.obj
          } else {
            this.costpricebook = {}
          }
        })
      },
      exportExceltable(val) {
        this.initContent = []
        this.initContentLeft = []
        this.initContentRight = []
        var seedcode = ''
        var seedname = ''
        var RL = ''
        var columns = this.tableData[0]['column']
        for (let i in columns) {
          if (columns[i] == 'R/L') {
            RL = 'R/L'
          }
        }
        var billmap = this.tableData[0]['billmap']
        for (let i in  billmap) {
          if ((billmap.length - 1) == i) {
            break
          }
          if (RL) {
            var type = billmap[i][1]['R/L']
            var objtype = {X: '', Y: '', P: '', type: type}
            for (let j in billmap[i]) {
              if (billmap[i][j]['球镜']) {
                objtype.Y = billmap[i][j]['球镜']
              } else if (billmap[i][j]['柱镜']) {
                objtype.X = billmap[i][j]['柱镜']
              } else if (billmap[i][j]['数量']) {
                objtype.P = billmap[i][j]['数量']
              } else if (billmap[i][j]['seedcode']) {
                seedcode = billmap[i][j]['seedcode']
              } else if (billmap[i][j]['产品名称'] && billmap[i][j]['产品名称'] != '合计') {
                seedname = billmap[i][j]['产品名称']
              }
            }
            if (type == 'L') {
              this.initContentLeft.push(objtype)
            } else if (type == 'R') {
              this.initContentRight.push(objtype)
            }
          } else {
            var obj = {X: '', Y: '', P: ''}
            for (let j in billmap[i]) {
              if (billmap[i][j]['球镜']) {
                obj.Y = billmap[i][j]['球镜']
              } else if (billmap[i][j]['柱镜']) {
                obj.X = billmap[i][j]['柱镜']
              } else if (billmap[i][j]['数量']) {
                obj.P = billmap[i][j]['数量']
              } else if (billmap[i][j]['seedcode']) {
                seedcode = billmap[i][j]['seedcode']
              } else if (billmap[i][j]['产品名称']) {
                seedname = billmap[i][j]['产品名称']
              }
            }
            this.initContent.push(obj)
          }
        }
        getPrice({seedcode: seedcode, filterType: "cost", notneedconnectprice: true}).then((response) => {
          if (response.data.code == 0 && response.data.obj) {
            this.costpricebook = response.data.obj
            this.$nextTick(() => {
              this.xcolumn = []
              this.ycolumn = []
              var bookcontent = this.costpricebook.BookContent
              var content = this.initContent
              if (content.length > 0) {
                bookcontent.forEach(o => {
                  let temp1 = this.xcolumn.filter(item => {
                    return item == o.X
                  })
                  if (temp1.length == 0) {
                    this.xcolumn.push(o.X.toFixed(2))
                  }
                  let temp2 = this.ycolumn.filter(item => {
                    return item == o.Y
                  })
                  if (temp2.length == 0) {
                    this.ycolumn.push(o.Y.toFixed(2))
                  }
                })
              }
              this.xcolumn.sort((a, b) => {
                return parseFloat(b) - parseFloat(a)
              })
              this.xcolumn.unshift('球\\柱')
              this.xcolumn.push("合计")
              this.ycolumn.sort((a, b) => {
                return parseFloat(b) - parseFloat(a)
              })
              //下面按照格式拼接
              let data = [] //导出的数据,
              this.ycolumn.forEach(y => {
                let heji = 0;
                let temp1 = {}
                temp1["球\\柱"] = y
                this.xcolumn.forEach(x => {
                  for (let i in content) {
                    if (parseFloat(content[i].X) == x && parseFloat(content[i].Y) == y) {
                      temp1[x] = content[i].P
                      if (Number(content[i].P))
                        heji += content[i].P
                      break;
                    }
                  }
                })
                temp1['合计'] = heji
                data.push(temp1)
              })
              //导出合计计算
              var hj = {"球\\柱": "合计"}
              var zhj = 0;
              this.xcolumn.forEach(x => {
                if (x != "球\\柱" && x != "合计") {
                  hj[x] = 0
                  data.forEach(item => {
                    if (Number(item[x])) {
                      hj[x] = hj[x] + item[x]
                    }
                  })
                  zhj += hj[x]
                }
                //计算总合计
                if (x == "合计") {
                  hj[x] = zhj
                }
              })
              data.push(hj)
              let title = this.controlData.erpserial + " " + "【" + seedcode + "】" + seedname + "【" + new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "】"

              let header1 = this.xcolumn.map(item => parseFloat(item) > 0 ? "+" + item : item)
              // 非RL时导出抬头为3行：第一行商品名称+商品编码，第二行订单号+GY.NO+导出时间，第三行列名
              var row1 = []
              row1[0] = seedname  // 商品名称，跨8列
              row1[8] = "商品编码：" + seedcode  // 商品编码，跨3列
              var row2 = []
              row2[0] = "订单号：" + this.controlData.erpserial  // 订单号，跨3列
              row2[3] = "GY.NO：" + (this.controlData.tracknum || "")  // GY.NO，跨3列
              row2[6] = formatTimeToStr(new Date())  // 导出时间，跨4列
              var biaoti = [row1, row2]
              var biaotiMerge = [
                [[1, 8], [9, 11]],
                [[1, 3], [4, 6], [7, 10]]
              ]

              if (RL) {
                var bookcontentleft = []
                var bookcontentright = []
                for (let i in bookcontent) {
                  var flage = true
                  for (let j in  this.initContentLeft) {
                    if (bookcontent[i].X == this.initContentLeft[j].X && bookcontent[i].Y == this.initContentLeft[j].Y) {
                      bookcontentleft.push(this.initContentLeft[j])
                    }
                  }
                  if (flage) {
                    bookcontent[i].P = 0
                    bookcontentleft.push(bookcontent[i])
                  }
                }
                for (let i in bookcontent) {
                  var flage = true
                  for (let j in  this.initContentRight) {
                    if (bookcontent[i].X == this.initContentRight[j].X && bookcontent[i].Y == this.initContentRight[j].Y) {
                      bookcontentright.push(this.initContentRight[j])
                    }
                  }
                  if (flage) {
                    bookcontent[i].P = ''
                    bookcontentright.push(bookcontent[i])
                  }
                }
                var dataexcel = {
                  initContentLeft: JSON.stringify(bookcontentleft),
                  initContentRight: JSON.stringify(bookcontentright),
                  seedcode: seedcode,
                  seedname: seedname,
                  businessType: 'inventoryDetails'
                }
                exportExcel(dataexcel, title)
              } else {
                this.$exportExcel(header1, this.xcolumn, data, title, biaoti, undefined, biaotiMerge)
              }
            })
          } else {
            this.costpricebook = {}
          }

        })

      },
      show() {
        this.isDisable = false;
        this.dialogSeeVisible = true;
      },
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },
      showDetail(item, isupdate, tabledata) {
        if (this.isBack) {
          listBar({outordernum: this.controlData.erpserial}).then(response => {
            if (response.data.obj.rows.length > 0) {
              this.$message({
                message: '已扫码，不允许修改！',
                type: 'warning'
              })
            } else {
              this.showDetailNext(item, isupdate, tabledata);
            }
          });
        } else {
          this.showDetailNext(item, isupdate, tabledata);
        }
      },
      showDetailNext(item, isupdate, tabledata){
        console.log(isupdate)
        if (isupdate == 0) {
          getDetail({seedcode: item[0].seedcode}).then(response => {
            var tableData = response.data.obj
            var scancodes = []
            if (tableData.noscancode == 1) {
              if (this.scancodes.length > 0) {
                //唯一码扫码后  查看
                var flage = true
                for (let i in this.scancodes) {
                  if (item[0].seedcode == this.scancodes[i].seedcode) {
                    scancodes.push(this.scancodes[i])
                    flage = false
                  }
                }
                if (flage) {
                  var obj = {}
                  obj.seedcode = item[0].seedcode
                  obj.seedname = item[1].产品名称
                  obj.cangkucode = this.controlData.cangkucode
                  obj.erpserial = this.controlData.erpserial
                  obj.totalnumber = 1
                  obj.goodsbarcode = ''
                  scancodes.push(obj)
                }
                //商品未扫唯一码的
                if (scancodes.length == 0) {
                  var obj = {}
                  obj.seedcode = item[0].seedcode
                  obj.seedname = item[1].产品名称
                  obj.cangkucode = this.controlData.cangkucode
                  obj.erpserial = this.controlData.erpserial
                  obj.totalnumber = 1
                  obj.goodsbarcode = ''
                  scancodes.push(obj)
                }
              } else {
                var obj = {}
                obj.seedcode = item[0].seedcode
                obj.seedname = item[1].产品名称
                obj.cangkucode = this.controlData.cangkucode
                obj.erpserial = this.controlData.erpserial
                obj.totalnumber = 1
                obj.goodsbarcode = ''
                scancodes.push(obj)
              }
              var scancodeData = []
              for (let i in this.scancodes) {
                if (this.scancodes[i].goodsbarcode) {
                  scancodeData.push(this.scancodes[i])
                }
              }
              //scancodes为初始化数据，item[item.length - 4].数量为选择商品的数量，item[0].seedcode为商品编码，this.isshowqr 控制确认按钮，
              //this.scancodes为确认入库的数据，用来在扫码时判断是否重复码
              this.$refs.ScanCode.show(scancodes, item[item.length - 4].数量, item[0].seedcode, this.isshowqr, scancodeData)
            } else {
              this.$refs.seeddetail.show()
              this.$refs.seeddetail.initData(this.controlData.unitguid, item[0].seedcode, item[1].产品名称, isupdate, "", tabledata, this.isshowqr)
            }
          })
        } else {
          this.$refs.seeddetail.show()
          var seedcode = item[0].seedcode
          if (this.controlData.isdistribute == 80||this.controlData.isdistribute == 88) {
            seedcode = ''
          }
          this.$refs.seeddetail.initData(this.controlData.unitguid, seedcode, item[1].产品名称, isupdate, "", tabledata, this.isshowqr)
        }
      },
      getRemark(remark) {
        if (remark) {
          try {
            let temp = JSON.parse(remark)
            temp.forEach(item => {
              if (item.type == "客户留言") {
                return item.msg
              }
            })
          } catch (ex) {
          }
        }
        return ""
      },
      afterCheckIn() {
        this.$emit('bindGrid');
        this.dialogSeeVisible = false;
      },
      beforeupdate(showQRCode){
        this.showQRCode=showQRCode;
        this.scancodes=this.caiGouRukuData;
        this.update();
      },
      update() {
        if (this.noscancode && this.scancodes.length == 0) {
          this.$message({
            message: '请扫唯一码！',
            type: 'warning'
          })
          return
        }
        this.isDisable = true
        if (JSON.parse(localStorage.getItem("hpapi_parames")).other.oddrequired == 'true') {
          if (!this.logisticstracknum) {
            this.$message({
              message: '请输入跟踪单号',
              type: 'error'
            })
            this.isDisable = false
            return
          }
        }
        //检查扫码数量
        var newNum = 0
        var billmapList = this.tableData[0].billmap
        for (let i = 0; i < billmapList.length; i++) {
          var number = billmapList[i][billmapList[i].length - 1]['bcode'] == undefined ? 0 : billmapList[i][billmapList[i].length - 1]['bcode']
          newNum += number
        }
        //如果已经扫过码（唯一码或光度码），检查数量
        if (this.caiGouRukuData.length > 0 || newNum > 0) {
          if (this.oldTotalNum != newNum) {
            // 数量不一致时，提示拆单入库
            const _this = this;
            this.$confirm(
              '已扫数量(' + newNum + ')与订单数量(' + this.oldTotalNum + ')不一致，是否只入库已扫部分（拆单）？',
              '数量不一致',
              {
                confirmButtonText: '拆单入库',
                cancelButtonText: '取消',
                type: 'warning'
              }
            ).then(() => {
              // 用户确认拆单入库，使用updateFast接口
              _this.isSplitOrder = true;
              _this.doUpdate();
            }).catch(() => {
              // 用户取消
              _this.isDisable = false;
            });
            return;
          }
        }
        //没有扫过码或数量一致，全部入库
        this.isSplitOrder = false;
        this.doUpdate();
      },
      doUpdate() {
        if (this.controlData.invoicesource == 1) {
          this.$message({
            message: '未审核的采购订单！',
            type: 'warning'
          })
          return
        }
        this.controlData.warehousename='';
        if(this.warehouse&&this.warehouse.length>1) {
          for (let i in this.warehouse) {
            if (this.warehouse[i].serial == this.controlData.warehouse) {
              this.controlData.warehousename = this.warehouse[i].name;
              break;
            }
          }
        }else{
          this.controlData.warehouse=''
        }
        //拆单入库使用updateFast接口
        if (this.isSplitOrder) {
          this.doSplitUpdate();
          return;
        }
        //入库
        updatebuyorder({
          unitguid: this.unitguid,
          tracknum: this.tracknum.trim(),//供应商单号
          logisticstracknum: this.logisticstracknum.trim(),//跟踪单号
          warehouse:this.controlData.warehouse,
          warehousename:this.controlData.warehousename,
          scancodes: JSON.stringify(this.scancodes)
        }).then(response => {
          if (response.data.code == 0) {
            if(this.supplytaskid){
              this.$refs.ScanCodeSupplyer.postPurchaseIn();//触发供应商出入库
            }else if(this.showQRCode) {
              this.openQRCode();
            }
            if (this.isBack&&this.$refs.QRCodeScan1) {//退货出库的时候需要保存 唯一码
              this.$refs.QRCodeScan1.saveQRCode(this.controlData.erpserial);
            }
            this.$message({
              message: '保存成功',
              type: 'success'
            })
            this.handlelog();
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
            this.isDisable = false
          }
          this.dialogSeeVisible = false;
          //刷新列表
          this.$emit('bindGrid');
        });
        //
      },
      //拆单入库，使用updateFast接口
      doSplitUpdate() {
        const _this = this;
        //构建details数组
        var details = [];
        var billmapList = this.tableData[0].billmap;
        for (let i = 0; i < billmapList.length; i++) {
          var item = billmapList[i];
          var seedname = this.getMapValue(item, '产品名称');
          if (seedname == '合计') continue;
          var originalQty = parseFloat(this.getMapValue(item, '数量')) || 0;
          var scannedQty = item[item.length - 1]['bcode'] == undefined ? 0 : item[item.length - 1]['bcode'];
          var seedcode = this.getMapValue(item, 'seedcode');
          var packagesize = this.getMapValue(item, 'packagesize');
          var X = this.getMapValue(item, '柱镜') || '';
          var Y = this.getMapValue(item, '球镜') || '';
          var type = this.getMapValue(item, 'type') || '';
          details.push({
            seedname: seedname,
            seedcode: seedcode,
            packagesize: packagesize,
            number: originalQty,
            buynumber: scannedQty,
            X: X,
            Y: Y,
            type: type
          });
        }
        //判断是否存在其他订单（目前固定为false，因为拆单时原单还在）
        var otherorder = false;
        updateFastbuyorder({
          unitguid: this.unitguid,
          tracknum: this.tracknum.trim(),
          logisticstracknum: this.logisticstracknum.trim(),
          warehouse: this.controlData.warehouse,
          warehousename: this.controlData.warehousename,
          otherorder: otherorder ? '1' : '0',
          details: JSON.stringify(details)
        }).then(response => {
          if (response.data.code == 0) {
            _this.$message({
              message: '拆单入库成功',
              type: 'success'
            });
            _this.handlelog();
          } else {
            _this.$message({
              message: response.data.msg,
              type: 'error'
            });
            _this.isDisable = false;
          }
          _this.dialogSeeVisible = false;
          _this.$emit('bindGrid');
        }).catch(() => {
          _this.isDisable = false;
        });
      },
      openQRCode() {
        var arrGood = []
        for (let i in this.controlData.billmap) {
          var row = this.controlData.billmap[i];
          if(row["产品名称"]=='合计')continue;
          arrGood.push({
            "inordernum": this.controlData.erpserial,
            "cangkucode": this.controlData.cangkucode,
            "seedcode": row["seedcode"],
            "seedname": row["产品名称"],
            "packagesize": row["packagesize"],
            "number": row["数量"]
          });
        }
        this.$refs.QRCodeCreate1.show(this.controlData.erpserial, false, false, arrGood);
      },
      /**
       * 显示采购订单
       * @param row 采购订单的信息
       * @param isbuyorder 是否是采购订单（0是销售订单点击，1和空是采购订单点击）
       * @param isshowconfirm(显示确认采购的按钮)
       * @param roletype
       * @param isupdatechange(显示是否需要采购修改)
       * @param groupguid(点击详情时)
       */
      initData(row, isbuyorder, isshowconfirm, roletype, isupdatechange, groupguid) {
        this.initForm()
        this.isDisable=true;
        for (let i in row.jxcformdetailDOList) {
          if (row.jxcformdetailDOList[i].filltemplate == "40"||row.jxcformdetailDOList[i].filltemplate == "80") {
            this.flage = false;
            break;
          }
        }
        this.status = row.status
        this.erpserial = row.erpserial
        this.unitguid = row.unitguid
        //是否是采购单点击跳转按钮，
        this.isbuyorder = isbuyorder;
        this.roletype = roletype
        if (isupdatechange) {
          this.isupdatechange = true
        } else {
          this.isupdatechange = false
        }

        //显示确认按钮
        if (isshowconfirm && isshowconfirm == 1) {
          this.isshowqr = true
        } else {
          this.isshowqr = false
        }
        if (isbuyorder == 0) {
          this.unitguid = JSON.parse(row.buyinfo).erpserial
        } else {
          this.unitguid = row.unitguid
        }
        this.initContent = []
        this.initContentLeft = []
        this.initContentRight = []
        printingbuy({
          ugg: JSON.stringify({
            unitguid: this.unitguid,
            unitgroup: 3,
            isbuyorder: isbuyorder,
            groupguid: groupguid,
            erpserial1: row.ordernum,
            filltemplate: row.filltemplate,
          })
        }).then(response => {
          this.saleorder = response.data.obj.saleorder;
          this.controlData = response.data.obj.detail;
          this.imgpath = window.API_ROOT + "/api/avatar/getBarcode?content=" + this.controlData.erpserial;
          if(response.data.obj.filltemplate&&response.data.obj.filltemplate=='80')
            this.flage=false;

          if(this.controlData.physicalstorecode) {
            this.supplytaskid = this.controlData.physicalstorecode;
          }
          if(this.controlData.cangkucode) {
            for (let i in this.jxcstoreData) {
              if (this.jxcstoreData[i].cangkucode == this.controlData.cangkucode) {
                if (this.jxcstoreData[i].warehouse) {
                  this.warehouse = JSON.parse(this.jxcstoreData[i].warehouse)
                  if (!this.controlData.warehouse) {
                    this.controlData.warehouse=this.warehouse[0].serial;
                    for (let j in this.warehouse) {
                      var cus=this.warehouse[j].cus;
                      for(let row in cus){
                        if(cus[row]==this.controlData.pcustomerserial){//默认库位
                          this.controlData.warehouse = this.warehouse[j].serial;
                          break;
                        }
                      }
                    }
                  }
                }
                break;
              }
            }
          }

          this.showedit=true;//!(this.controlData.isdistribute==80);
          this.tracknum = this.controlData == '' ? '' : this.controlData.tracknum
          this.logisticstracknum = this.controlData == '' ? '' : this.controlData.logisticstracknum
          this.FastCheck = this.controlData.tracknum && this.controlData.tracknum.length >= 14 && this.controlData.tracknum.substr(0, 2) == '42';
          this.tableData = response.data.obj.goodsDetail;
          //是否需要唯一码扫码
          // if (response.data.obj.scancodes) {
          //   var scancodes = response.data.obj.scancodes
          //   for (let i in scancodes) {
          //     if (scancodes[i].noscancode == 1) {
          //       this.noscancode = true;
          //       break
          //     }
          //   }
          // }
          if (this.saleorder.erpserial) {
            this.showtablehead = true
          } else {
            this.showtablehead = false
          }

          if (this.tableData.length > 0) {
            for (let g = 0; g < this.tableData.length; g++) {
              //取出表头
              let temparr = []
              let biaoji = 0
              this.column = []
              for (let i in this.tableData[g]['billmap']) {
                for (let j in this.tableData[g]['billmap'][i]) {
                  if (j == "R/L") {
                    biaoji = 1
                  }
                  if (j != "seedcode" && j != "R/L" && j != "数量" && j != "说明" && j != "产品名称" && j != "球镜" && j != "柱镜" && j != "轴位" && !this.contains(j, temparr) && j != "销售单号" && j != "本次采购数量" && j != "unitguid" && j != "已采购" && j != "办结日期" && j != "单价" && j != "总价") {
                    temparr.push(j)
                  }
                }
              }
              //对表头排序
              this.column.push("seedcode")
              if (biaoji == 1) {
                this.column.push("R/L")
              }
              this.column.push("产品名称")
              if (this.flage) {
                this.column.push("球镜")
                this.column.push("柱镜")
                this.column.push("轴位")
              }
              this.column = this.column.concat(temparr)
              //this.column.push("销售单号")
              this.column.push("数量")
              this.column.push("办结日期")
              this.column.push("bcode")
              // this.column.push("单价")
              // this.column.push("总价")
              this.tableData[g]['column'] = this.column
              this.tableData[g]['billmap'] = this.tableData[g]['billmap'].map(o1 => this.column.map(o2 => {
                if (o2 == '数量' && o1["产品名称"] != '合计') {
                  this.oldTotalNum += o1[o2]
                }
                let ob = {}
                if (o2 == 'bcode') {
                  ob = {bcode: 0}
                } else {
                  ob[o2] = o1[o2]
                }
                return ob
              }))

              this.isBack = this.oldTotalNum < 0;
            }
          }
          //公共参数解析
          for (let i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].parametermap) {
              let biaoji = 0;
              this.$set(this.tableData[i], 'formpropertyData', [])

              for (let j in this.tableData[i].parametermap) {

                if (biaoji % 4 == 0) {
                  let temp = {}
                  temp[j] = this.tableData[i].parametermap[j]
                  this.tableData[i].formpropertyData.push(temp)
                } else {
                  this.tableData[i].formpropertyData[this.tableData[i].formpropertyData.length - 1][j] = this.tableData[i].parametermap[j]
                }
                biaoji++
              }
            }
          }


          this.isDisable=false;
        });

      }
      ,
      //调整订单数量，将原采购单数量修改成扫码确认的数量
      adjust() {
        var newNum = 0
        var message = ''
        var billmapList = this.tableData[0].billmap
        for (let i = 0; i < billmapList.length; i++) {
          var number = billmapList[i][billmapList[i].length - 1]['bcode'] == undefined ? 0 : billmapList[i][billmapList[i].length - 1]['bcode']
          newNum += number
        }
        message = '原订单' + this.oldTotalNum + '片,将调整到' + newNum + '片'
        this.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          adjustNumber({
            erpserial: this.tableData[0].erpserial,
            billmap: JSON.stringify(this.tableData[0].billmap),
          }).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: '调整成功',
                type: 'success'
              })
              //刷新调整后的数量
              for(let i in this.tableData[0]['billmap']){
                var item=this.tableData[0]['billmap'][i]
                var number=0
                var packagesize='';
                for(let j in item) {
                  for (let key in item[j]) {
                    if (key == 'bcode')
                      number = item[j][key];
                    if (key == 'packagesize')
                      packagesize = item[j][key];
                  }
                }

                for(let j in item) {
                  for (let key in item[j]) {
                    if (key == '数量')
                      item[j][key] = number;
                  }
                }

                for(let j in this.controlData.billmap){
                  if(this.controlData.billmap[j]['packagesize']==packagesize){
                    this.controlData.billmap[j]['数量']=number;
                    break;
                  }
                }
              }
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            duration: 1500,
            message: '已取消'
          });
        });

      }
      ,
      //初始化参数
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.warehouse=[]
        this.isBack=false;
        this.supplytaskid=''
        this.imgpath = ''
        this.FastCheck = false
        this.showedit=true
        this.oldTotalNum = 0
        this.isDisable = false//防止多次提交
        this.goodsbarcode = ''//商品条码
        this.storegoodsbarcode = ''//库存商品唯一条码
        this.goodsbar = {}
        this.caiGouRukuData = []
        this.seedcode = ""
        this.groupguid = ""
        this.column = []
        this.tableData = []
        this.unitguid = ""
        this.cangkucode = ""
        this.cangkuname = ""
        this.erpserial = ""
        this.flage = true
        this.scancodes = []
        this.noscancode = false
      }
    }
    ,
    mounted() {
      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj
      })
      checkModuleRight({name: 'qrcodescan'}).then(reponse => {
        this.qrcodescan = reponse.data.code == 0;
      });
    }
    ,

    components: {
      BuyOrderEditSeedDetail,
      HandlelogList,
      StorageBadDetail,
      BaoSunDetail,
      StorageBadOut,
      CstagreementEdit,
      ScanCode,
      ScanCodeBatch,
      BuyfromList,
      BuyfromListEssilor,
      BuyfromFastCheck,
      ScanCodeSupplyer4Buy,
      QRCodeCreate,
      QRCodeScan
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>



// WEBPACK FOOTER //
// src/components/testorder/buyagreement/BuyorderDetail.vue